import React from 'react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="main">
		
		<section className="section-padding footer-mid">
				<div className="col-12 mb-10">
                    <div className="footer-bottom"></div>
                </div>
            <div className="container pt-15 pb-20">
                <div className="row">
                    <div className="col">
                        <div className="widget-about font-md mb-md-3 mb-lg-3 mb-xl-0 wow animate__animated animate__fadeInUp" data-wow-delay="0">
                            <div className="logo mb-10">
                                <a href="index.html" className="mb-5"><img src="/assets/imgs/theme/logo.png" alt="logo"/></a>
                                <p className="font-lg text-heading">Online Shopping Site for CCTV, Computer, Laptop & More.</p>
                            </div>
                            <ul className="contact-infor">
                                <li><img src="/assets/imgs/theme/icons/icon-location.svg" alt=""/><strong>Address : </strong> <span>Plot No 353, Road No 19, Jawahar Nagar, Goregaon West, Mumbai 400104.</span></li>
                                <li><img src="/assets/imgs/theme/icons/icon-contact.svg" alt=""/><strong>Call Us : </strong><span>(+91) - 8828485299</span></li>
                                <li><img src="/assets/imgs/theme/icons/icon-email-2.svg" alt=""/><strong>Email : </strong><span>skcart84@gmail.com</span></li>
                                <li><img src="/assets/imgs/theme/icons/icon-clock.svg" alt=""/><strong>Hours : </strong><span>10:00 - 18:00, Mon - Sat</span></li>
                            </ul>
                        </div>
                    </div>
                    <div className="footer-link-widget col wow animate__animated animate__fadeInUp" data-wow-delay=".1s">
                        <h4 className="widget-title">Company</h4>
                        <ul className="footer-list mb-sm-5 mb-md-0">
                            <li><a href="#">About Us</a></li>
                            <li><a href="#">Delivery Information</a></li>
                            <li><a href="#">Privacy Policy</a></li>
                            <li><a href="#">Terms &amp; Conditions</a></li>
                            <li><a href="#">Contact Us</a></li>
                            <li><a href="#">Support Center</a></li>
                            <li><a href="#">Careers</a></li>
                        </ul>
                    </div>					
                    <div className="footer-link-widget col wow animate__animated animate__fadeInUp" data-wow-delay=".2s">
                        <h4 className="widget-title">Account</h4>
                        <ul className="footer-list mb-sm-5 mb-md-0">
                            <li><a href="#">Sign In</a></li>
                            <li><a href="#">View Cart</a></li>
                            <li><a href="#">My Wishlist</a></li>
                            <li><a href="#">Track My Order</a></li>
                            <li><a href="#">Help Ticket</a></li>
                            <li><a href="#">Shipping Details</a></li>
                            <li><a href="#">Compare products</a></li>
                        </ul>
                    </div>
                    <div className="footer-link-widget col wow animate__animated animate__fadeInUp" data-wow-delay=".3s">
						<iframe width="650" height="300" frameBorder="0" scrolling="no" marginHeight="0" marginWidth="0" src="https://maps.google.com/maps?width=100%25&amp;height=300&amp;hl=en&amp;q=Plot%20No%20353,%20Road%20No%2019,%20Jawahar%20Nagar,%20GOregaon%20West%20Mumbai.%20400104.+(SK%20COMPUTER%20SOLUTION)&amp;t=&amp;z=16&amp;ie=UTF8&amp;iwloc=B&amp;output=embed"><a href="https://www.mapsdirections.info/calcular-la-poblaci�n-en-un-mapa">Mapa de poblaci�n interactivo</a></iframe>
                    </div>
                </div>
			</div>
		</section>
        
        <div className="container pb-10 wow animate__animated animate__fadeInUp" data-wow-delay="0">		
            <div className="row align-items-center">
                <div className="col-12 mb-10">
                    <div className="footer-bottom"></div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6">
                    <p className="font-sm mb-0">Design By : <strong className="text-brand">SK COMPUTER SOLUTION</strong></p>
                </div>
                <div className="col-xl-6 col-lg-6 text-center d-none d-xl-block">
                    <div className="hotline d-lg-inline-flex mr-30">
                        <img src="/assets/imgs/theme/icons/phone-call.svg" alt="hotline" />
                        <p>8828485299<span>Working 8:00 - 22:00</span></p>
                    </div>
                    <div className="hotline d-lg-inline-flex">
                        <img src="/assets/imgs/theme/icons/phone-call.svg" alt="hotline" />
                        <p>8828485299<span>24/7 Support Center</span></p>
                    </div>
                </div>
                <div className="col-xl-3 col-lg-6 col-md-6 text-end d-none d-md-block">
                    <div className="mobile-social-icon">
                        <h6>Follow Us</h6>
                        <a href="#"><img src="/assets/imgs/theme/icons/icon-facebook-white.svg" alt=""/></a>
                        <a href="#"><img src="/assets/imgs/theme/icons/icon-twitter-white.svg" alt=""/></a>
                        <a href="#"><img src="/assets/imgs/theme/icons/icon-instagram-white.svg" alt=""/></a>
                        <a href="#"><img src="/assets/imgs/theme/icons/icon-pinterest-white.svg" alt=""/></a>
                        <a href="#"><img src="/assets/imgs/theme/icons/icon-youtube-white.svg" alt=""/></a>
                    </div>
                    <p className="font-sm">Up to 15% discount on your first subscribe</p>
                </div>
            </div>
			
        </div>
    </footer>
  );
};

export default Footer;